import { Card, CardContent } from '@mui/material';
import { PropsWithChildren, memo } from 'react';
import { SEVERITY_COLORS, Severity } from '../../../enums/Severity';

type Props = PropsWithChildren<{}>;

export const ItemCardSkeleton = memo(({ children }: Props) => {
  return (
    <Card
      sx={{
        borderRadius: 0,
        backgroundColor: 'white',
        borderLeft: `4px solid`,
        borderLeftColor: SEVERITY_COLORS[Severity.NO_WARNING].main,
        borderTop: `1px solid rgba(0, 0, 0, 0.12)`,
        width: 1,
        overflow: 'visible',
      }}
    >
      <CardContent sx={{ py: 1, pb: '12px !important' }}>{children}</CardContent>
    </Card>
  );
});
